(function(){
  var root = document.getElementById('nhd-palpitations-protocol');
  if(!root) return;

  /* without a viewport meta a phone lays this out at 980px and scales it down, which makes
     every element look tiny. Shopify's theme already ships one, so this is a no-op there. */
  /* full bleed: the theme wraps every section in a padded, max-width container.
     Tag the ancestor so the stylesheet can neutralise it. Paired with a :has()
     rule in the CSS for browsers that get there first. */
  var host = root.closest ? root.closest('.shopify-section') : null;
  if(host){ host.classList.add('nhd-palpoffer-host'); }

  if(!document.querySelector('meta[name="viewport"]')){
    var vp = document.createElement('meta');
    vp.name = 'viewport';
    vp.content = 'width=device-width, initial-scale=1';
    (document.head || document.documentElement).appendChild(vp);
  }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if('IntersectionObserver' in window && !reduced){ root.classList.add('nhdPRO-js'); }

  /* exact ECG path length: uniform draw + sweep speed, concrete keyframes for full browser support */
  var paths = root.querySelectorAll('.nhdPRO-ecg-base, .nhdPRO-ecg-active');
  var ecgLen = 0;
  for(var i=0;i<paths.length;i++){
    try{
      var L = paths[i].getTotalLength();
      ecgLen = ecgLen || L;
      paths[i].style.setProperty('--nhdPROlen', L);
    }catch(e){}
  }
  if(ecgLen && !reduced){
    var kf = document.createElement('style');
    kf.textContent = '@keyframes nhdPROsweep{0%{stroke-dashoffset:90;}100%{stroke-dashoffset:-' + Math.ceil(ecgLen) + 'px;}}' +
                     '@keyframes nhdPROdraw{to{stroke-dashoffset:0;}}';
    root.appendChild(kf);
  }

  /* mobile menu toggle */
  var navEl = root.querySelector('.nhdPRO-nav');
  var burger = root.querySelector('.nhdPRO-nav-burger');
  if(navEl && burger){
    burger.addEventListener('click', function(){
      var open = navEl.classList.toggle('nhdPRO-nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.textContent = open ? '✕' : '☰';
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    var navLinks = navEl.querySelectorAll('.nhdPRO-nav-links a');
    for(var n=0;n<navLinks.length;n++){
      navLinks[n].addEventListener('click', function(){
        navEl.classList.remove('nhdPRO-nav-open');
        burger.setAttribute('aria-expanded','false');
        burger.textContent = '☰';
        burger.setAttribute('aria-label','Open menu');
      });
    }
  }

  /* ---- UTM forwarder ----------------------------------------------------
     Every outbound link ships with all five parameters hardcoded, so the page
     is correct with no JS at all. When the visitor ARRIVES with their own
     tagged URL (an AC replay email, an affiliate, a Meta ad), that acquisition
     data is the truer answer for source / medium / campaign / term, so it is
     carried through to the product page.

     utm_content is NEVER inherited. It is the placement of the click being
     made on THIS page, which is what gives the card level breakout. Inheriting
     it would collapse all nine cards back into one row.

     Only the cross-domain links to naturalheartdoctor.com still carry UTMs,
     so this is what preserves attribution across the WordPress hop.
     Matches the forwarder already live on WP /optipressure/.
     Values follow the NHD UTM Builder: all lowercase, hyphens between words,
     never an underscore. Spec: NHD_Cycle2_UTM_Spec_Palpitations.md v1.3 section 1,
     a slot left blank does not stay blank, it back-fills from the visitor's
     previous tagged click. ---------------------------------------------- */
  try{
    var inbound = new URLSearchParams(window.location.search);
    var CARRY = ['utm_source','utm_medium','utm_campaign','utm_term'];
    var carried = {};
    for(var c=0;c<CARRY.length;c++){
      var v = inbound.get(CARRY[c]);
      if(v){ carried[CARRY[c]] = v; }
    }
    if(Object.keys(carried).length){
      var links = root.querySelectorAll('a[href^="http"]');
      for(var L=0;L<links.length;L++){
        var u;
        try{ u = new URL(links[L].getAttribute('href'), window.location.origin); }
        catch(e){ continue; }
        if(!u.searchParams.get('utm_content')) continue;  /* untagged link, leave alone */
        for(var k in carried){ u.searchParams.set(k, carried[k]); }
        links[L].setAttribute('href', u.toString());
      }
    }
  }catch(e){}

  /* smooth in-page anchors */
  var anchors = root.querySelectorAll('a[href^="#nhd-"]');
  for(var j=0;j<anchors.length;j++){
    anchors[j].addEventListener('click', function(e){
      var t = document.getElementById(this.getAttribute('href').slice(1));
      if(t){ e.preventDefault(); t.scrollIntoView({behavior: reduced ? 'auto' : 'smooth', block:'start'}); }
    });
  }

  /* ---- GA4 measurement ---------------------------------------------------
     Links to shop.naturalheartdoctor.com carry NO UTMs on purpose. Per the NHD
     UTM Builder, tagging a link to the same host starts a fresh GA4 session and
     re-attributes the visitor, which would throw away how they actually arrived.
     The session keeps its real source all the way to checkout instead.

     Card level reporting comes from these events rather than from utm_content:
       view_item_list  once per tier, when that tier first comes into view
       select_item     on a click of a card image or card button
       cta_click       on the non product CTAs
     GTM forwards these to GA4. See INSTALL.md section 6 for the tag recipe.
     ---------------------------------------------------------------------- */
  window.dataLayer = window.dataLayer || [];
  function nhdPush(obj){ try{ window.dataLayer.push(obj); }catch(e){} }
  /* GA4 merges the ecommerce object between pushes, so a previous event's items
     can leak into the next one. Clear it first. */
  function nhdPushEc(obj){ nhdPush({ecommerce:null}); nhdPush(obj); }

  function nhdItem(card){
    return {
      item_id:   card.getAttribute('data-nhd-item-id'),
      item_name: card.getAttribute('data-nhd-item-name'),
      item_list_name: card.getAttribute('data-nhd-list'),
      index: parseInt(card.getAttribute('data-nhd-index'), 10) || 0,
      item_brand: 'Natural Heart Doctor'
    };
  }

  /* select_item and cta_click, one delegated listener */
  root.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if(!a) return;
    var card = a.closest('.nhdPRO-card');
    if(card && card.getAttribute('data-nhd-item-id')){
      var placement = a.classList.contains('nhdPRO-card-img') ? 'card-image' : 'card-button';
      nhdPushEc({ event:'select_item', nhd_placement: placement,
                ecommerce:{ item_list_name: card.getAttribute('data-nhd-list'),
                            items:[ nhdItem(card) ] } });
      return;
    }
    var cta = a.getAttribute('data-nhd-cta');
    if(cta){ nhdPush({ event:'cta_click', nhd_cta_id: cta,
                       nhd_destination: a.getAttribute('href') || '' }); }
  }, true);

  /* view_item_list, once per tier, so card click through rate is computable */
  var tiers = root.querySelectorAll('.nhdPRO-tier');
  if('IntersectionObserver' in window && tiers.length){
    var listSeen = {};
    var listIO = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        var cards = en.target.querySelectorAll('.nhdPRO-card[data-nhd-item-id]');
        if(!cards.length) return;
        var listName = cards[0].getAttribute('data-nhd-list');
        if(listSeen[listName]) { listIO.unobserve(en.target); return; }
        listSeen[listName] = true;
        var items = [];
        for(var t=0;t<cards.length;t++){ items.push(nhdItem(cards[t])); }
        nhdPushEc({ event:'view_item_list',
                  ecommerce:{ item_list_name: listName, items: items } });
        listIO.unobserve(en.target);
      });
    }, {threshold:0.25});
    for(var ti=0;ti<tiers.length;ti++){ listIO.observe(tiers[ti]); }
  }

  /* scroll reveal */
  var els = root.querySelectorAll('.nhdPRO-reveal');
  function showAll(){ for(var k=0;k<els.length;k++){ els[k].classList.add('nhdPRO-in'); } }
  if(!('IntersectionObserver' in window) || reduced){ showAll(); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('nhdPRO-in'); io.unobserve(en.target); }
    });
  }, {threshold:0.12, rootMargin:'0px 0px -6% 0px'});
  for(var m=0;m<els.length;m++){ io.observe(els[m]); }
})();
